import { useTranslations } from '@vocab/react';
import { Box, Text, TextLink } from 'braid-design-system';
import React from 'react';

import { useAnalyticsContext } from '../../../../../modules/analytics/AnalyticsContext';
import { Experience } from '../../../../../types';
import { useAppContext } from '../../../../AppContext';

import translations from './.vocab';

const ExperienceNudge = () => {
  const { t } = useTranslations(translations);
  const {
    analytics: { trackLink },
  } = useAnalyticsContext();

  const { experience, getClientHref } = useAppContext();

  const text =
    experience === Experience.Hirer
      ? 'Are you looking for a job?'
      : 'Are you an employer?';
  const href = getClientHref(
    '',
    experience === Experience.Hirer ? Experience.Candidate : Experience.Hirer,
  );

  return (
    <Box padding="medium">
      <Text align="right">
        <TextLink
          href={href}
          weight="regular"
          onClick={() =>
            trackLink({
              eventName: 'navigation_pressed',
              linkText: text,
              linkPosition: 'body',
              isThirdPartyLink: 'false',
            })
          }
        >
          {t(text)}
        </TextLink>
      </Text>
    </Box>
  );
};

export default ExperienceNudge;
